var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "search-table" },
        [
          _c("el-date-picker", {
            staticStyle: { width: "115px" },
            attrs: {
              clearable: false,
              type: "month",
              placeholder: "Chọn tháng",
              "value-format": "M-yyyy",
              format: "MM-yyyy",
            },
            on: { change: _vm.handelUpdateDate },
            model: {
              value: _vm.monthAndYear,
              callback: function ($$v) {
                _vm.monthAndYear = $$v
              },
              expression: "monthAndYear",
            },
          }),
          _c(
            "el-select",
            {
              staticStyle: { width: "120px" },
              attrs: { placeholder: "Trạng thái" },
              on: { change: _vm.handleChangeKidStatus },
              model: {
                value: _vm.dataSearch.kidStatus,
                callback: function ($$v) {
                  _vm.$set(_vm.dataSearch, "kidStatus", $$v)
                },
                expression: "dataSearch.kidStatus",
              },
            },
            _vm._l(_vm.kidStatusListExcel, function (item) {
              return _c("el-option", {
                key: item.key,
                attrs: { value: item.key, label: item.value },
              })
            }),
            1
          ),
          _c(
            "el-select",
            {
              staticStyle: { width: "203px" },
              attrs: { placeholder: "Chọn nhóm" },
              on: { change: _vm.handleChangeKidGroup },
              model: {
                value: _vm.dataSearch.idGroup,
                callback: function ($$v) {
                  _vm.$set(_vm.dataSearch, "idGroup", $$v)
                },
                expression: "dataSearch.idGroup",
              },
            },
            _vm._l(_vm.kidGroupList, function (item, index) {
              return _c("el-option", {
                key: index,
                attrs: { value: item.id, label: item.nameGroup },
              })
            }),
            1
          ),
          _c(
            "el-select",
            {
              staticStyle: { width: "203px" },
              attrs: {
                placeholder: "Chọn trạng thái",
                multiple: "",
                "collapse-tags": "",
                clearable: "",
              },
              on: {
                change: _vm.handleChangeMoneyStatus,
                "remove-tag": _vm.handleChangeMoneyStatus,
                clear: _vm.handleChangeMoneyStatus,
              },
              model: {
                value: _vm.statusList,
                callback: function ($$v) {
                  _vm.statusList = $$v
                },
                expression: "statusList",
              },
            },
            _vm._l(_vm.statusOrderList, function (item, index) {
              return _c("el-option", {
                key: index,
                attrs: { value: item, label: item },
              })
            }),
            1
          ),
          _c("el-input", {
            staticStyle: { width: "240px" },
            attrs: { clearable: "", placeholder: "Nhập tên, biệt danh" },
            on: { clear: _vm.handleClearKidName },
            nativeOn: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.handleChangeKidName.apply(null, arguments)
              },
            },
            scopedSlots: _vm._u([
              {
                key: "append",
                fn: function () {
                  return [
                    _c("el-button", {
                      attrs: { icon: "el-icon-search" },
                      on: { click: _vm.handleSearchResultByName },
                    }),
                  ]
                },
                proxy: true,
              },
            ]),
            model: {
              value: _vm.kidName,
              callback: function ($$v) {
                _vm.kidName = $$v
              },
              expression: "kidName",
            },
          }),
          _c(
            "el-select",
            {
              staticStyle: { width: "100px" },
              attrs: { placeholder: "Đợt thu" },
              on: { change: _vm.handleChangeCollectionTurn },
              model: {
                value: _vm.dataSearch.collectionTurn,
                callback: function ($$v) {
                  _vm.$set(_vm.dataSearch, "collectionTurn", $$v)
                },
                expression: "dataSearch.collectionTurn",
              },
            },
            _vm._l(_vm.collectionTurn, function (item) {
              return _c("el-option", {
                key: item,
                attrs: { value: item, label: `Đợt ${item}` },
              })
            }),
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "table-content row-data",
          staticStyle: { "margin-top": "12px" },
        },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loadingData,
                  expression: "loadingData",
                },
              ],
              attrs: {
                "empty-text": _vm.textTable,
                data: _vm.tableData,
                "element-loading-text": _vm.$tableLoading,
                "element-loading-spinner": "el-icon-loading",
                "element-loading-background": "rgba(255,255,255,0)",
                "header-cell-style": _vm.tableHeaderColor,
                "max-height": _vm.$tableMaxHeight,
                border: "",
              },
              on: { "selection-change": _vm.handleSelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", align: "center", width: "55" },
              }),
              _c("el-table-column", {
                attrs: {
                  type: "index",
                  fixed: "left",
                  label: "STT",
                  width: "50",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: { width: "250", fixed: "left", label: "Họ tên" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-tooltip", { attrs: { placement: "top" } }, [
                          _c(
                            "div",
                            { attrs: { slot: "content" }, slot: "content" },
                            [
                              _vm._v(
                                "\n              Mã học sinh: " +
                                  _vm._s(scope.row.kidCode)
                              ),
                              _c("br"),
                              _vm._v(
                                "Bố/Mẹ: " +
                                  _vm._s(scope.row.fatherPhone) +
                                  " - " +
                                  _vm._s(scope.row.motherPhone) +
                                  "\n            "
                              ),
                            ]
                          ),
                          _c("span", [_vm._v(_vm._s(scope.row.fullName))]),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  width: "100",
                  label: "Biệt danh",
                  prop: "nickName",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: { align: "center", width: "150", label: "Trạng thái" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          { class: _vm.getStatusColor(scope.row.status) },
                          [_vm._v(_vm._s(_vm.getStatusValue(scope.row.status)))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  align: "right",
                  width: "150",
                  label: "Phải thu tháng này",
                  prop: "sumMoney",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm._f("formatCurrency")(scope.row.sumMoney)
                            ) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  align: "right",
                  label: "Đã thu",
                  prop: "collectedMoney",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm.getStatusValue(scope.row.status) !==
                        "Chưa có hóa đơn"
                          ? _c(
                              "el-button",
                              {
                                staticClass: "click-in-row",
                                attrs: { type: "text" },
                              },
                              [
                                scope.row.collectedMoney
                                  ? _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("formatCurrency")(
                                            scope.row.collectedMoney
                                          )
                                        )
                                      ),
                                    ])
                                  : _c("span", [_c("b", [_vm._v("-")])]),
                              ]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "right", label: "Tiền mặt", prop: "cashMoney" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm._f("formatCurrency")(scope.row.cashMoney)
                            ) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  align: "right",
                  label: "Chuyển khoản",
                  prop: "transferMoney",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm._f("formatCurrency")(scope.row.transferMoney)
                            ) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  align: "right",
                  width: "200",
                  label: "Thiếu / Thừa còn lại",
                  prop: "afterMoney",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm._f("formatCurrency")(scope.row.afterMoney)
                            ) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Tác vụ",
                  fixed: "right",
                  align: "center",
                  width: "140",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          { staticStyle: { display: "inline-flex" } },
                          [
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  content: "Hóa đơn từ HP Onekids",
                                  placement: "top",
                                },
                              },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary", size: "mini" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.orderKidsCashierMethod(
                                          scope.row
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("Tạo HĐ")]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c("SelectRevenueByGroupDialog", {
            ref: "SelectRevenueByGroupDialog",
            attrs: {
              isOpenSelectRevenueByGroupDialog:
                _vm.isOpenSelectRevenueByGroupDialog,
              isActivatedAccount: _vm.isActivatedAccount,
            },
            on: { "dialog-close": _vm.closeSelectRevenueByGroupDialog },
          }),
          _c("InvoiceCreateManyDialog", {
            attrs: {
              invoicePurpose: _vm.invoicePurpose,
              isOpenInvoiceCreateDialog: _vm.isOpenInvoiceCreateManyDialog,
              kidCodes: _vm.selectedKidCodes,
            },
            on: { "dialog-close": _vm.closeInvoiceCreateManyDialog },
          }),
        ],
        1
      ),
      _c(
        "el-row",
        { staticStyle: { "margin-top": "15px" } },
        [
          _c(
            "el-col",
            {
              staticStyle: {
                display: "inline-flex",
                "justify-content": "right",
              },
              attrs: { span: 15 },
            },
            [
              _c("el-pagination", {
                staticStyle: {
                  "margin-right": "5.2rem",
                  "margin-left": "auto",
                },
                attrs: {
                  "current-page": _vm.currentPagePagination,
                  "page-sizes": _vm.listSizeLimit,
                  "page-size": _vm.sizeLimit,
                  layout: "prev, pager, sizes, next",
                  total: _vm.sizeLimit * _vm.totalPages,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                  "update:currentPage": function ($event) {
                    _vm.currentPagePagination = $event
                  },
                  "update:current-page": function ($event) {
                    _vm.currentPagePagination = $event
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "el-col",
            {
              staticStyle: {
                display: "inline-flex",
                "justify-content": "right",
              },
              attrs: { span: 9 },
            },
            [
              _c(
                "div",
                { staticClass: "batch-action-menu" },
                [
                  _c(
                    "el-dropdown",
                    {
                      attrs: { trigger: "click" },
                      on: { command: _vm.handleBatchCommand },
                      scopedSlots: _vm._u([
                        {
                          key: "dropdown",
                          fn: function () {
                            return [
                              _c(
                                "el-dropdown-menu",
                                { staticClass: "batch-action-dropdown-menu" },
                                [
                                  _vm.checkPermission([
                                    "electronic-invoice-create-draft",
                                  ])
                                    ? _c(
                                        "el-dropdown-item",
                                        {
                                          attrs: { command: "createManyDraft" },
                                        },
                                        [
                                          _vm._v(
                                            "\n                Tạo nhiều HĐ nháp\n              "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    },
                    [
                      _c(
                        "el-button",
                        { attrs: { type: "success", size: "medium" } },
                        [
                          _vm._v("\n            Tác vụ\n            "),
                          _c("i", {
                            staticClass: "el-icon-arrow-down el-icon--right",
                          }),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }